<template>
  <v-dialog :value="true" width="443" persistent>
    <v-card class="pt-5 px-3 pb-3 add-lucky-number-content">
      <h1 class="mb-6 px-2">Adicionar número da sorte</h1>
      <div class="scrollable-area px-2">
        <span class="mb-4">Insira o CPF que você deseja adicionar um número da sorte</span>

        <div class="search-container">
          <mf-search
            v-model="luckyNumber.documentNo"
            :vMask="['###.###.###-##']"
            :loading="loading"
            label="CPF"
            placeholder="000.000.000-00"
            outlined
            dense
            :error-messages="$v.luckyNumber.documentNo.$error || invalidCpf ? 'Insira um CPF válido' : ''"
          />
        </div>

        <div class="consumer">
          <h2 class="mb-2">Consumidor:</h2>
          <div class="d-flex align-center">
            <p class="ma-0">
              Nome: <b>{{ name || '-' }}</b>
            </p>
            <p class="ma-0 ml-8">
              CPF: <b>{{ name ? luckyNumber.documentNo : '-' }}</b>
            </p>
          </div>
        </div>

        <div class="d-flex justify-space-between mt-4" style="gap: 12px">
          <div>
            <p class="mb-3">Insira o código do cupom:</p>
            <v-text-field
              v-model="luckyNumber.couponNumber"
              :error-messages="$v.luckyNumber.couponNumber.$error ? 'Insira o código do cupom' : ''"
              outlined
              label="Código do cupom"
              :value="luckyNumber.couponNumber"
              dense
            />
          </div>

          <div>
            <p class="mb-3">Selecione a loja:</p>
            <mf-select-units-dialog
              single-select
              dense
              outlined
              :selected-units.sync="luckyNumber.selectedUnit"
              :units="units"
              :tag-list="tagList"
              :group-list="unitsGroups"
              :unit-error="$v.luckyNumber.selectedUnit.$error"
              hide-ecommerce-configuration
            />
          </div>
        </div>

        <p class="mb-3">Selecione a quantidade de números da sorte a serem adicionados:</p>
        <div class="number-input-container">
          <mf-number-input
            v-model="luckyNumber.luckyNumbersAmount"
            auto-format
            outlined
            label="Quantidade"
            :value="luckyNumber.luckyNumbersAmount"
            :min="1"
            show-arrows
            dense
            :error-messages="luckyNumbersAmountErrorMessage"
          />
        </div>

        <p class="mb-3">Importe uma imagem do cupom fiscal referente a compra do consumidor válida para o sorteio.</p>
        <div class="d-flex flex-column align-center justify-center pb-6">
          <mf-upload-image
            v-model="luckyNumber.couponImageLink"
            dense
            file-name="cupom_fiscal"
            :loading="loading"
            :disabled="loading"
            @snackbar-error="showSnackbarError"
            @upload="saveImage"
          />
          <p v-if="$v.luckyNumber.couponImageLink.$error" class="mt-1 error-message">Insira a imagem do cupom fiscal</p>
        </div>
      </div>

      <mf-action-buttons
        class="mx-2 mt-2 fixed-action-buttons"
        :primary-button="{
          text: 'Gerar números',
          action: generateNumbers,
          isVisible: true,
          isLoading: loading,
        }"
        :extra-button="{
          text: 'Cancelar',
          action: () => $emit('close'),
          isVisible: true,
          isLoading: loading,
        }"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { minLength, required, minValue, maxValue } from 'vuelidate/lib/validators'
import { QUERY_GET_USERS } from '@/modules/clientes/gerenciamento/graphql'
import { MUTATION_SINGLE_UPLOAD_BASE64 } from '@/graphql'
import { MANUALLY_GENERATE_RAFFLE_LUCKY_NUMBERS } from '../../graphql'
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'AddLuckyNumberDialog',
  data: () => ({
    luckyNumber: {
      documentNo: '',
      luckyNumbersAmount: 1,
      selectedUnit: [],
      couponNumber: null,
      couponImageLink: '',
    },
    name: '',
    luckyNumbersAmountErrorMessage: '',
    openDialog: false,
    invalidCpf: false,
    loading: false,
    force: false,
  }),

  computed: {
    ...mapState({
      raffle: (state) => state.sorteio.raffle,
    }),
    ...mapGetters(['units', 'tagList', 'unitsGroups']),
    units() {
      return this.raffle.units.map((unit) => unit)
    },
    variables() {
      const { documentNo, luckyNumbersAmount, selectedUnit, couponNumber, couponImageLink } = this.luckyNumber

      return {
        raffle_id: this.$route.params.id,
        document_no: documentNo.replace(/\D/g, ''),
        lucky_numbers_amount: luckyNumbersAmount,
        unit_id: selectedUnit[0],
        coupon_number: couponNumber,
        coupon_image_link: couponImageLink,
        force: this.force,
      }
    },
  },

  watch: {
    'luckyNumber.documentNo'(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.name = ''
        this.getUserByCpf()
      }
    },
    openDialog(newValue) {
      if (newValue) {
        this.force = false
        this.invalidCpf = false
        this.luckyNumber = {
          ...this.luckyNumber,
          documentNo: '',
          luckyNumbersAmount: 1,
          selectedUnit: [],
          couponNumber: null,
          couponImageLink: '',
        }
        this.$v.$reset()
      }
    },
  },

  methods: {
    showSnackbarError(snackbar) {
      this.$snackbar(snackbar)
    },

    async getUserByCpf() {
      if (this.luckyNumber.documentNo.length === 14) {
        this.loading = true
        this.invalidCpf = false
        const variables = {
          search: this.luckyNumber.documentNo,
          page: 1,
          pageSize: 1,
          sort: [],
          sortDirection: [],
        }
        try {
          const {
            data: { users },
          } = await this.$apollo.query({
            query: QUERY_GET_USERS,
            variables,
          })
          this.name = users?.users[0]?.name || ''
          if (!users?.users[0]?.name) {
            this.invalidCpf = true
            this.$snackbar({ message: 'CPF não encontrado.', snackbarColor: 'error' })
          }
        } catch (error) {
          this.$snackbar({ message: 'Erro ao buscar CPF.', snackbarColor: 'error' })
        } finally {
          this.loading = false
        }
      }
    },

    async saveImage({ base64, filename }) {
      this.loading = true
      await this.$apollo
        .mutate({
          mutation: MUTATION_SINGLE_UPLOAD_BASE64,
          variables: { base64, filename },
          context: {
            uri: this.$microservicesUrls['upload'],
          },
        })
        .then(({ data: { singleUploadBase64 } }) => {
          const { url } = singleUploadBase64
          this.luckyNumber.couponImageLink = url
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.$snackbar({ message: 'Erro ao subir imagem.', snackbarColor: 'error' })
        })
    },

    async generateNumbers() {
      this.$v.$reset()
      this.$v.$touch()

      if (!this.$v.luckyNumber.luckyNumbersAmount.required || !this.$v.luckyNumber.luckyNumbersAmount.minValue) {
        this.luckyNumbersAmountErrorMessage = 'Campo obrigatório.'
      } else if (!this.$v.luckyNumber.luckyNumbersAmount.maxValue) {
        this.luckyNumbersAmountErrorMessage = ' A quantidade deve ser menor ou igual a 100'
      }

      if (this.$v.$error || this.invalidCpf) {
        this.$snackbar({ message: 'Preencha todos os campos corretamente', snackbarColor: 'error' })
        return
      }

      this.loading = true
      try {
        await this.$apollo.mutate({
          mutation: MANUALLY_GENERATE_RAFFLE_LUCKY_NUMBERS,
          variables: this.variables,
        })
        const { lucky_numbers_amount } = this.variables
        const numberLabel = lucky_numbers_amount === 1 ? 'Número' : 'Números'
        this.$snackbar({ message: `${numberLabel} da sorte adicionado com sucesso`, snackbarColor: 'success' })
        this.$emit('lucky-number-added')
        this.openDialog = false
      } catch (error) {
        const errorReason = error.graphQLErrors?.[0]?.extensions?.errors?.[0]?.path
        if (errorReason === 'lucky_numbers_amount') this.forceAddNumber()
        else this.$snackbar({ message: 'Ocorreu um erro ao adicionar número da sorte.', snackbarColor: 'error' })
      } finally {
        this.loading = false
      }
    },

    async forceAddNumber() {
      const confirmed = await this.$confirm({
        title: 'Adicionar números',
        message: `O limite de números por CPF ou por cupom foi atingido. Tem certeza que deseja adicionar números acima do limite configurado no sorteio?`,
        confirmText: 'Adicionar',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (confirmed) {
        this.force = true
        this.generateNumbers()
      }
    },
  },
  validations() {
    return {
      luckyNumber: {
        documentNo: {
          required,
          minLength: minLength(14),
        },
        luckyNumbersAmount: {
          required,
          minValue: minValue(1),
          maxValue: maxValue(100),
        },
        selectedUnit: {
          required,
          minLength: minLength(1),
        },
        couponNumber: {
          required,
          minLength: minLength(2),
        },
        couponImageLink: {
          minLength: minLength(2),
        },
      },
    }
  },
}
</script>

<style scoped lang="scss">
.add-lucky-number-content {
  .scrollable-area {
    height: 450px;
    overflow: auto;
  }
  h1 {
    font-size: 22px;
    color: $cinza-d20;
  }

  span {
    line-height: 20px;
    display: block;
    font-size: 14px;
    color: $cinza-d20;
  }

  .search-container {
    width: 260px;
  }

  .number-input-container {
    width: 170px;
  }

  .consumer {
    h2 {
      font-weight: 400;
      color: $cinza-d20;
      font-size: 16px;
    }

    p {
      font-size: 14px;
      color: $cinza-0;
    }
  }

  p {
    color: $cinza-d10;
    font-size: 14px;
    line-height: 20px;
  }

  .error-message {
    color: $vermelho-0;
  }
}

.fixed-action-buttons {
  position: sticky;
  bottom: 0;
  background-color: #ffffff;
  z-index: 999;
}
</style>
